




























import { Component, Vue, Inject, Ref } from 'vue-property-decorator';

import TipologiainterventoList from './TipologiainterventoList.vue';
import EditTipologiaintervento from './tipologiaintervento/EditTipologiaintervento.vue';
import { CrudService } from '@/data/services/crud.service';
import { Tipologiaintervento } from '@/data/models/tipologiaintervento.model';
import TipologiainterventoFilter from './TipologiainterventoFilter.vue';
import { Search } from '@/data/models/search.model';
import store, { State } from '@/store';
import { BModalComponent } from 'buefy/types/components';

@Component({
	components: {
		TipologiainterventoList,
		EditTipologiaintervento,
		TipologiainterventoFilter,
	},
})
export default class Tipologieintervento extends Vue {
	@Inject('CrudService') crudService!: CrudService<Tipologiaintervento>;

	@Ref('list') list!: TipologiainterventoList;
	@Ref('filter') filter!: TipologiainterventoFilter;

	state!: State;

	constructor() {
		super();
		this.state = store;
	}

	mounted() {
		this.filter.search();
	}

	onSearch(event: Search) {
		this.list.advancedSearch = event;
		this.list.loadTipologieintervento();
	}

	saveTipologiaintervento(value: Tipologiaintervento, modal: BModalComponent) {
		
		this.crudService
			.createEntity(Tipologiaintervento, 'intervento', value)
			.then(() => {
				this.list.loadTipologieintervento();
				this.$buefy.notification.open({
					message: this.$t('success-save') as string,
					type: 'is-success',
				});
				modal.close();
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			});
	}

	addTipologiaintervento() {
		const modal = this.$buefy.modal.open({
			parent: this,
			component: EditTipologiaintervento,
			hasModalCard: true,
			canCancel: false,
			events: {
				submit: (value: Tipologiaintervento) => {
					this.saveTipologiaintervento(value, modal);
				},
			},
		});
	}

	editTipologiaintervento(item: Tipologiaintervento) {
		this.openTipologiaintervento(item);
	}

	openTipologiaintervento(item: Tipologiaintervento) {
		const modal = this.$buefy.modal.open({
			parent: this,
			component: EditTipologiaintervento,
			props: {
				tipologiaintervento: item,
			},
			hasModalCard: true,
			canCancel: false,
			events: {
				submit: (value: Tipologiaintervento) => {
					this.saveTipologiaintervento(value, modal);
				},
			},
		});
	}

	deleteTipologiaintervento(item: Tipologiaintervento) {
		this.$buefy.dialog.confirm({
			message: this.$t('warning-tipologiaintervento-delete') as string,
			type: 'is-danger',
			hasIcon: true,
			cancelText: this.$t('annulla') as string,
			onConfirm: () => {
				this.crudService
					.deleteEntity(Tipologiaintervento, 'intervento', item)
					.then(() => {
						this.$buefy.notification.open({
							message: this.$t('success-save') as string,
							type: 'is-success',
						});
						this.list.loadTipologieintervento();
					})
					.catch((error) => {
						this.$buefy.notification.open({
							message: error.msg,
							type: 'is-danger',
						});
					});
			},
		});
	}

}
